<template>
  <div class="delivery-history">
    <div class="modal delivery-history-modal" style="position: absolute!important">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <p class="panel-heading">
            <span @click="workflowInfo" class="has-text-weight-semibold">Delivery History</span>
          </p>
          <div>
            <a
              class="panel-block"
              :style="backgroundStyle(t)"
              v-for="t in transactions"
              :key="t.id"
              @click="moreInfo(t)"
            >
              <span class="tags has-addons single-line">
                <span class="tag is-white" style="padding: 0 3px">{{ date(t) }}</span>
                <span class="tag is-grey">{{ shortTime(t) }}</span>
                <!-- <span class="tag is-grey" style="padding: 0 3px">+{{ daysAgo(t) }}</span> -->
                <span class="tag is-dark" style="padding: 0 3px">#{{ referenceNumber(t) }}</span>
                <span class="tag" :style="transactionStyle(t)">
                  <i class="fas fa-cog fa-spin" v-if="isOngoing(t)" />
                  <i class="fas fa-thumbs-up" v-if="t.state === 'alighted'" />
                  <span class="has-text-weight-semibold" v-if="showState(t)">{{ t.state }}</span>
                </span>
                <span class="tag">
                  <i class="fas fa-shuttle-van" v-if="t.driver">&nbsp;</i>
                  {{ t.driver.name }}
                </span>
                <span class="tag is-white">
                  <i class="fa fa-user">&nbsp;</i>
                  {{ t.customer.name || t.customer.phone_number }}
                </span>
              </span>
            </a>
          </div>
        </section>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "DeliveryHistoryModal",
  components: {},
  data() {
    return {
      transactions: [],
      workflowID: null
    };
  },
  computed: {
    shortWorkflowID() {
      if (!this.workflowID) return "";
      return this.workflowID.substr(this.workflowID.length - 5);
    }
  },
  mounted() {
    console.log("mount DeliveryWorkflowModal");
    EventBus.$on("DELIVERY_HISTORY", id => {
      console.log("DELIVERY_HISTORY, workflow:", id);
      this.transactions = []; // reset
      this.workflowID = id;
      this.getTransactionsInfo();
    });
  },
  beforeDestroy() {
    console.log("destroy WorkflowStatsModal");
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    workflowInfo() {
      this.infoAlert(`Workflow ID ${this.shortWorkflowID}`);
      this.getTransactionsInfo();
    },
    shortTime(t) {
      var str = new Date(t.created_at).toLocaleTimeString("en-GB");
      return str.slice(0, 5);
    },
    date(t) {
      var dt = new Date(t.created_at);
      var dd = dt.getDate();
      var mm = dt.getMonth() + 1;
      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;
      return `${dd}/${mm}`;
    },
    backgroundStyle(t) {
      if (this.isToday(t)) return "background-color:lightyellow";
    },
    isToday(t) {
      var a = new Date().getDate();
      var b = new Date(t.created_at).getDate();
      if (a === b) return true;
      return false;
    },
    daysAgo(t) {
      // var ms = new Date().getTime() - new Date(t.created_at).getTime();
      // return ms / (1000 * 60 * 60 * 24);
      var days = new Date().getDate() - new Date(t.created_at).getDate();
      return days;
    },
    getTransactionsInfo() {
      var loader = this.loadingDots();
      this.$store
        .dispatch("getDeliveryTransactionsByWorkflow", this.workflowID)
        .then(res => {
          console.log("getDeliveryTransactionsByWorkflow", res.data);
          this.transactions = res.data;
        })
        .catch(err => this.apiError(err))
        .finally(() => loader.hide());
    },
    transactionStyle(t) {
      var color = "pink";
      if (t.state === "alighted") color = "lightgreen";
      var liveStates = ["initiated", "confirmed", "driver_arrived", "enroute"];
      if (liveStates.includes(t.state)) color = "lightblue";
      return `background-color: ${color}`;
    },
    isOngoing(t) {
      if (t.is_ongoing && t.state !== "alighted") return true;
      return false;
    },
    showState(t) {
      if (t.state === "alighted" || t.state === "enroute") return false;
      return true;
    },
    referenceNumber(t) {
      if (!t.data.ref) return "?";
      return t.data.ref;
    },
    green(isOngoing) {
      if (isOngoing) return `background-color: lightgreen`;
      return `background-color: pink`;
    },
    lastFive(id) {
      return id.substr(id.length - 5);
    },
    moreInfo(t) {
      var shortID = this.lastFive(t.id);
      var updated = new Date(t.updated_at);
      var timeDiff = Math.round((new Date() - updated) / (1000 * 60));
      var prettyTime = `${timeDiff} mins ago`;
      if (timeDiff > 60) {
        timeDiff = Math.round(timeDiff / 60);
        prettyTime = `${timeDiff} hours ago`;
      }
      var createdTime = new Date(t.created_at).toLocaleTimeString("en-GB");
      var driverName = "None";
      var driverPhone = "None";
      if (t.driver) {
        driverName = t.driver.name;
        driverPhone = t.driver.phone_number;
      }
      this.$swal({
        // title: t.customer.name,
        html: `<div style='text-align:left'>
        Customer <strong>${t.customer.name} (${t.customer.phone_number})</strong><br>
        Driver <strong>${driverName} (${driverPhone})</strong><br>
        State <strong>${t.state}</strong><br>
        Pickup <strong>${t.data.pickup_stop.name}</strong><br>
        Dropoff <strong>${t.data.dropoff_stop.name}</strong><br>
        Created <strong>${createdTime}</strong><br>
        Updated <strong>${prettyTime}</strong><br>
        ID <strong>${shortID}</strong></div>`,
        showConfirmButton: false
      }).then(result => {
        console.log(result);
        if (result.dismiss === "cancel") {
          this.deleteWorkerRole(r);
        }
      });
    },
    deleteWorkerRole(r) {
      var loader = this.loadingDots();
      this.$store
        .dispatch("deleteRole", r.id) // should soft delete
        .then(res => {
          this.console("deleteWorkerRole", res);
          this.getRolesInfo();
        })
        .catch(err => console.error(err))
        .finally(() => loader.hide());
    }
  }
};
</script>

<style scoped>
.panel-block {
  font-size: 1.15em;
  white-space: nowrap;
  overflow: auto;
  padding: 4px 6px;
}
.panel-block::-webkit-scrollbar {
  display: none;
}
.distance {
  font-size: 0.75em;
  color: grey !important;
}
.modal-card-body {
  padding: 12px;
}
.tag {
  padding: 0 4px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
}
.tags::-webkit-scrollbar {
  display: none;
}
</style>